module.exports = __webpack_public_path__ + "static/img/image1.164fa7cf.png";